import QueuedSketchOrdersVendor from './QueuedVendorSketchOrders';

export default QueuedSketchOrdersVendor;
